import { Flex } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '~/components/Button';
import Icon from '~/components/Icon';
import Input from '~/components/Input';
import LoadingOverlay from '~/components/LoadingOverlay';
import { Divider, Form, FormBottomWrapper, HeaderImg, Title } from '~/components/LoginElements';

const Wrapper = styled(Flex)`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--neutral-contrast);
`;

const StyledForm = styled(Form)`
  width: 404px;
`;

const StyledInput = styled(Input)`
  span {
    p {
      color: #1c2024;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0.4px;
      margin-bottom: 4px;
    }
  }
  input {
    color: ${props => props.theme.lightMedium};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.42px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 48, 0.11);
    background: rgba(255, 255, 255, 0.9);
    box-shadow:
      0px 1.5px 2px 0px rgba(0, 0, 0, 0.02) inset,
      0px 1.5px 2px 0px rgba(5, 5, 88, 0.02) inset;
    height: 32px;
  }
`;

const SubmitButton = styled(Button)`
  width: 100%;
  border-radius: 9999px;
  background: #1c2024;
  padding: 0px 16px;
  color: #fcfcfd;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.32px;
`;

const StyledDivider = styled(Divider)`
  margin: 16px 0px;
  gap: 12px;
  color: #60646c;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.48px;
`;

const StyledButton = styled.button`
  cursor: pointer;
  width: 344px;
  border-radius: 9999px;
  border: 1px solid rgba(1, 6, 47, 0.17);
  display: flex;
  height: 32px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background-color: #ffffff;
  color: #60646c;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.4px;
  div {
    margin-bottom: 3px;
  }
`;

const SsoWrapper = styled.div`
  width: 100%;
  justify-content: center;
  display: grid;
  gap: 12px;
`;

const SocialsButton = ({ history, text, svgName }) => {
  return (
    <StyledButton onClick={() => history.push('/login')}>
      <Icon
        name={svgName}
        height={16}
        width={16}
        color={null}
        inline
      />
      {text}
    </StyledButton>
  );
};

SocialsButton.propTypes = {
  history: PropTypes.any,
  text: PropTypes.string,
  svgName: PropTypes.string,
};

function SetPassword({ onSubmit, password, passwordAgain, loading, history }) {
  return (
    <Wrapper>
      <HeaderImg
        width={272}
        height={40}
        src={require('~/assets/graphics/onomondo.svg')}
      />
      <StyledForm onSubmit={onSubmit}>
        <Title>Welcome, set your password</Title>
        <StyledInput
          ref={password}
          name='password'
          type='password'
          label='New password'
          autoFocus
          placeholder='Enter password'
        />
        <StyledInput
          ref={passwordAgain}
          name='password'
          type='password'
          label='New password (again)'
          autoFocus
          placeholder='Enter password'
        />
        <FormBottomWrapper center>
          <SubmitButton
            variant='dark'
            type='submit'
            size='large'
          >
            Submit
          </SubmitButton>
        </FormBottomWrapper>
        <StyledDivider>or</StyledDivider>
        {loading && <LoadingOverlay />}

        <SsoWrapper>
          <SocialsButton
            history={history}
            text='Continue with Google'
            svgName='google'
          />
          {/* Not needed right now */}
          {/* <SocialsButton
          history={history}
          text='Continue with Microsoft'
          svgName='microsoft'
        /> */}
        </SsoWrapper>
      </StyledForm>
    </Wrapper>
  );
}

SetPassword.propTypes = {
  onSubmit: PropTypes.func,
  password: PropTypes.object,
  passwordAgain: PropTypes.object,
  loading: PropTypes.bool,
  history: PropTypes.any,
};

export default SetPassword;
